export { mock_dailyplantsummary as dailyplantsummary } from './dailyplantsummary/index';
export { mock_desktopmenu as desktopmenu } from './desktopmenu/index';
export { mock_menu as menu } from './menu/index';
export { mock_trendreport as trendreport } from './trendreport/index';



// WEBPACK FOOTER //
// ./src/mocks/index.ts